import { Button, ModalDialog } from 'vetrf-ui';
import React from 'react';
import classNames from 'classnames';
import styles from './ReportModal.module.scss';

type ReportModalProps = {
  isActual: boolean;
  label: string;
  onClose: () => void;
  reportCreateDate: string;
};

export const ReportModal = ({ isActual, label, onClose, reportCreateDate }: ReportModalProps) => (
  <ModalDialog
    bodyClass={classNames('modal-body', isActual ? styles.actual : styles.notActual)}
    headerClass={classNames('modal-header', isActual ? styles.actual : styles.notActual)}
    footerClass={classNames('modal-footer', isActual ? styles.actual : styles.notActual)}
    header="Сообщение"
    onClose={onClose}
    footer={
      <Button
        color="grey"
        iconColor="white"
        iconSize={100}
        onClick={onClose}
        size="sm"
        text="Закрыть"
      />
    }
  >
    {isActual
      ? `${label} содержит актуальные сведения`
      : `${label} содержит не актуальные сведения`}
    <br />
    Дата выписки: {reportCreateDate}
  </ModalDialog>
);
